import React from 'react'
import { Modal, Button } from "react-bootstrap";
import OtpInput from 'react-otp-input';
import RoundButton from '../components/ui/button/RoundButton.js';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getValidAccessToken } from '../services/oauthservice.js';
import { SET_PARTNER_SMS_CONFIG } from '../redux/Action/partnerSmsConfigAction.js';
import { encryptRSA } from '../services/encrypt.js';

export default function OtpModal(props) {
    const { show, handleClose, handleVerified, formData, sendOtp } = props
    const dispatch = useDispatch()

    const [otp, setOtp] = useState('');
    const [verifying, setVerifying] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [message, setMessage] = useState("");
    const { partnerDetail } = useSelector((state) => state.domainReducer);
    const [timer, setTimer] = useState(30);
    const { partnerSmsConfig } = useSelector((state) => state.partnerSmsConfig || {});
    const { OTP_LENGTH, IS_EMAIL_MANDATORY } = partnerSmsConfig

    const fetchPartnerSmsConfig = async (partnerId) => {
        try {
            if (!partnerId) {
                console.warn('Skipping SMS config fetch: partnerId is missing.');
                return;
            }

            const token = await getValidAccessToken();
            const baseUrl = process.env.REACT_APP_DIC_ADMIN_API;

            const response = await fetch(
                `${baseUrl}/get/partner/smsConfig?PARTNER_ID=${partnerId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = await response.json();

            if (data?.data?.length) {
                dispatch({
                    type: SET_PARTNER_SMS_CONFIG,
                    payload: data.data[0],
                });
            } else {
                console.warn('No SMS config found for partner.');
            }
        } catch (error) {
            console.error('Error fetching partner SMS config:', error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (!OTP_LENGTH) {
                await fetchPartnerSmsConfig(partnerDetail?.PARTNER_ID);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [OTP_LENGTH]);

    async function verifyOtp() {
        try {
            dispatch({ type: "LOADING", payload: true });
            setVerifying(true);

            const token = await getValidAccessToken();
            const request = {
                otp: otp,
                otpId: formData?.otpId,
            }
            const encrypted = await encryptRSA(request)
            const response = await fetch(
                `${process.env.REACT_APP_DIC_ADMIN_API}/v1/otp/internal-verify`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify({ encrypted }),
                }
            );

            const result = await response.json();

            if (result.success) {
                setOtpVerified(true);
                await handleVerified();
            } else {
                setMessage("Invalid OTP. Please try again.");
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            setMessage("Something went wrong while verifying OTP. Please try again.");
        } finally {
            setVerifying(false);
            dispatch({ type: "LOADING", payload: false });
        }
    }

    useEffect(() => {
        if (timer > 0) {
            const countdown = setTimeout(() => setTimer(timer - 1), 1000);
            return () => clearTimeout(countdown);
        }
    }, [timer]);

    const resendOtp = () => {
        sendOtp();       // your existing function
        setTimer(30);    // restart timer
    };

    return (
        <div>
            <Modal show={show} onHide={handleClose} centered dialogClassName="responsive-modal">
                <Modal.Body className="p-4">
                    <div className="text-center">
                        <h5 className="fw-bold mb-4">Enter Verification Code</h5>
                        {formData?.mobileNo && (
                            <p className="text-muted mb-4">
                                Code has been sent to{" "}
                                {IS_EMAIL_MANDATORY ? (
                                    // Masked Email
                                    (() => {
                                        const email = formData.eMailId || "";
                                        const [name, domain] = email.split("@");
                                        const maskedName =
                                            name.length > 2 ? name[0] + "****" + name.slice(-1) : name + "****";
                                        return `${maskedName}@${domain || ""}`;
                                    })()
                                ) : (
                                    // Masked Mobile
                                    `+968 ${"X".repeat(formData.mobileNo.length - 3) + formData.mobileNo.slice(-3)}`
                                )}
                            </p>
                        )}
                        {/* OTP Input */}
                        <div className="d-flex justify-content-center mb-4">
                            <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={OTP_LENGTH}
                                inputStyle={{
                                    width: "3rem",
                                    height: "3rem",
                                    fontSize: "1.25rem",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    textAlign: "center",
                                }}
                                renderSeparator={<span className="mx-2">-</span>}
                                renderInput={(props) => <input {...props} />}
                                isInputNum
                            />
                        </div>
                        <div className="mb-3">
                            {timer > 0 ? (
                                <p className="text-muted">Resend code in {timer}s</p>
                            ) : (
                                <button
                                    className="btn btn-link p-0 text-primary fw-semibold"
                                    onClick={resendOtp}
                                >
                                    Resend Code
                                </button>
                            )}
                        </div>
                        {/* Verify Button */}
                        <div className="d-grid gap-2 col-6 mx-auto">
                            <RoundButton
                                label={verifying ? "Verifying..." : "Verify OTP"}
                                iconClass="bi-chevron-right"
                                onClick={verifyOtp}
                                disabled={otp.length < 4 || verifying}
                                className="w-100"
                            />
                        </div>
                        {message && (
                            <p className="text-danger fw-semibold">{message}</p>
                        )}
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    )
}
